import { createReactComponent } from '@tabler/icons-react';

export const IconCustomMailGroup = createReactComponent(
  'outline',
  'customMailGroup',
  'CustomMailGroup',
  [
    [
      'path',
      {
        key: 'customMailGroup-path',
        d: 'M4.9,7.2h-1c-0.5,0-1,0.2-1.3,0.5C2.2,8,2,8.5,2,9v9.3c0,0.5,0.2,1,0.5,1.3c0.3,0.3,0.8,0.5,1.3,0.5h13c0.5,0,1-0.2,1.3-0.5c0.3-0.3,0.5-0.8,0.5-1.3V17 M5.2,5.7c0-0.5,0.2-1,0.5-1.3C6.1,4,6.6,3.8,7.1,3.8h13c0.5,0,1,0.2,1.3,0.5C21.8,4.7,22,5.2,22,5.7 M5.2,5.7V15c0,0.5,0.2,1,0.5,1.3c0.3,0.3,0.8,0.5,1.3,0.5h13c0.5,0,1-0.2,1.3-0.5C21.8,16,22,15.5,22,15V5.7 M5.2,5.7l8.4,5.6L22,5.7',
      },
    ],
  ]
);
